import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=2020520b&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.vue?vue&type=style&index=0&lang=less&"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=2020520b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020520b",
  null
  
)

export default component.exports